import React, { useCallback, useState, useEffect } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { FormControl, Button, Typography, Box, TextField, Slider } from '@mui/material';
import { styled } from '@mui/material/styles';
import MutationLoadingButton from 'components/MutationLoadingButton';

const SpigotEdit = ( {editObj: spigot, journeyStepId: id, onSave, onChangeEditState }) => {
    const { register, handleSubmit, formState: { errors }, getValues, control, setValue, reset } = useForm();

    // Reset form when spigot prop changes (e.g., after save)
    useEffect(() => {
        if (spigot) {
            const probability = spigot?.json_data?.spigot_data?.probability_of_journey;
            reset({
                probability: probability || 0.5
            });
        }
    }, [spigot, reset]);

    const onSubmit = () => {
        const probability = getValues('probability');
        //  const is_active = getValues('is_active');

        const formData = {
            'paths': {
                'spigot_data.probability_of_journey': probability
            }
        };

        // const formData = {
        //     is_active,
        //     probability
        // };

        if(onSave){
            onSave(formData);
        }
    };

    const handleCancel = () => {
        if( onChangeEditState ){
            onChangeEditState('cancel');
        }
    };

    return (
        <Box sx={{
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            flexGrow: 1,
            padding: '25px 15px',
            borderBottom: '1px solid #D5DDED'
        }}>
            <Box className='flow_query_filter create_audience'>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <Box display='flex' flexDirection='column' pt={1} pb={4}>
                        <Typography variant='subtitle1' gutterBottom>Travellers that will continue</Typography>
                        <Typography variant='body2' color='textSecondary' gutterBottom>
                            Set the percentage of travellers that will continue on this journey path
                        </Typography>
                        
                        <Controller
                            control={control}
                            name='probability'
                            defaultValue={spigot?.json_data?.spigot_data?.probability_of_journey || 0.5}
                            render={({ field: { onChange, value } }) => (
                                <Box sx={{ px: 2, py: 2 }}>
                                    <Slider
                                        value={value}
                                        onChange={(event, newValue) => onChange(newValue)}
                                        min={0}
                                        max={1}
                                        step={0.01}
                                        marks={[
                                            { value: 0, label: '0%' },
                                            { value: 0.25, label: '25%' },
                                            { value: 0.5, label: '50%' },
                                            { value: 0.75, label: '75%' },
                                            { value: 1, label: '100%' }
                                        ]}
                                        valueLabelDisplay="auto"
                                        sx={{ mt: 2 }}
                                    />
                                    <Box sx={{ textAlign: 'center', mt: 1 }}>
                                        <Typography variant='h6' color='primary'>
                                            {Math.round(value * 100)}% will continue
                                        </Typography>
                                        <Typography variant='body2' color='textSecondary'>
                                            {Math.round((1 - value) * 100)}% will exit
                                        </Typography>
                                    </Box>
                                </Box>
                            )}
                        />
                    </Box>
                </form>
            </Box>
            <Box display='flex' justifyContent='space-between' sx={{mx: 1, my: 1}}>
                <Button onClick={handleCancel} className='new_primary_button' style={{marginRight: 'auto'}}>
                    Cancel
                </Button>
                <MutationLoadingButton
                    mutation={null}
                    onClick={handleSubmit(onSubmit)}
                    className='new_primary_button'
                    type='submit'
                    style={{marginLeft: 'auto'}}
                >
                    Save
                </MutationLoadingButton>
            </Box>
        </Box>
    );
};

export default SpigotEdit; 